<template>
    <Head>
        <title>Авто выводы</title>
    </Head>

    <authenticated-layout :notifications="notifications" >

        <template #header>

        </template>

        <div class="flex flex-col gap-4 py-8">

            <div class="flex flex-row justify-between items-baseline px-6">
                <h1 class="text-2xl font-bold">Авто выводы</h1>
            </div>

            <div class="grid grid-cols-8 gap-6 px-6 items-end">
                <form action="#" method="get" class="col-span-2 flex flex-row gap-2 items-end" @submit.prevent="paginate(1)">
                    <v-input type="search" label="Поиск" placeholder="id/address/hash" class="grow" v-model="search"/>
                    <v-button>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current" viewBox="0 0 16 16">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                        </svg>
                    </v-button>
                </form>
                <v-select label="Тип" v-model="type" @change="paginate">
                    <option :value="null">Все</option>
                    <option v-for="t of result.types" :value="t">{{ t }}</option>
                </v-select>
                <v-select label="Статус" v-model="status" @change="paginate">
                    <option :value="null">Все</option>
                    <option v-for="s of result.statuses" :value="s">{{ s }}</option>
                </v-select>
            </div>

            <!--            body-->
            <div class="relative flex flex-col bg-white text-sm">

                <div class="grid grid-cols-8 items-end px-6 py-2 gap-x-4 font-bold sticky left-0 top-0 right-0 bg-white border-b">
                    <span class="col-span-3"></span>
                    <span class="text-center">Тип, Статус</span>
                    <span>Исходящая</span>
                    <span>Конечная</span>
                    <span>Комиссия</span>
                    <span class="text-center">Дата (UTC)</span>
                </div>

                <div class="grid grid-cols-8 items-center border-t px-6 py-2 gap-x-4" v-for="r of result.rows">
                    <div class="col-span-3 flex flex-col gap-2">
                        <div class="flex flex-col">
                            <v-label>ID</v-label>
                            <span class="font-mono">{{ r.id }}</span>
                        </div>
                        <div class="flex flex-col">
                            <v-label>Hash</v-label>
                            <span class="font-mono">{{ r.txId || '-' }}</span>
                        </div>
                        <div class="flex flex-col">
                            <v-label>Организация</v-label>
                            <Link v-if="r.organizationId" :href="route('organization', r.organization.id)"
                                  class="cursor-pointer text-blue-700">
                                {{ r.organization.name }}
                            </Link>
                        </div>
                        <div class="flex flex-col">
                            <v-label>Address From</v-label>
                            <span class="font-mono">{{ r.addressFrom || '-' }}</span>
                        </div>
                        <div class="flex flex-col">
                            <v-label>Address To</v-label>
                            <span class="font-mono">{{ r.addressTo || '-' }}</span>
                        </div>
                    </div>

                    <div class="flex flex-col gap-4 items-center">
                        <span>{{ r.type.split('_').join(' ') }}</span>
                        <div class="flex flex-col items-center">
                            <span class="text-center">{{ r.status.split('_').join(' ') }}</span>
                            <v-label v-if="r.rejectMessage">{{ r.rejectMessage }}</v-label>
                            <v-label v-if="r.errorMessage">{{ r.errorMessage }}</v-label>
                            <Link
                                v-if="r.status === 'ERROR' && r.prevStatus"
                                class="cursor-pointer text-green-500 hover:text-green-700"
                                :data="{ id: r.id }"
                                method="post"
                                :href="route('withdrawals.auto.push')"
                            >Протолкнуть</Link>
                        </div>
                    </div>

                    <div class="flex flex-col">
                        <span class="font-mono">{{ r.amountFrom }}</span>
                        <div class="flex flex-row gap-2">
                            <span>{{ r.currencyFrom.name || '' }}</span>
                            <span>{{ r.networkFrom.name || '' }}</span>
                        </div>
                        <div class="flex flex-row gap-2 text-gray-600 pt-4">
                            <span class="font-mono">{{ r.amountFromUSD }}</span>
                            <span>$</span>
                        </div>
                        <div class="flex flex-row gap-2 text-gray-600">
                            <span class="font-mono">{{ r.amountFromEUR }}</span>
                            <span>€</span>
                        </div>
                    </div>

                    <div class="flex flex-col">
                        <span class="font-mono">{{ r.amountTo }}</span>
                        <div class="flex flex-row gap-2">
                            <span>{{ r.currencyTo.name || '' }}</span>
                            <span>{{ r.networkTo.name || '' }}</span>
                        </div>
                        <div class="flex flex-row gap-2 text-gray-600 pt-4">
                            <span class="font-mono">{{ r.amountToUSD }}</span>
                            <span>$</span>
                        </div>
                        <div class="flex flex-row gap-2 text-gray-600">
                            <span class="font-mono">{{ r.amountToEUR }}</span>
                            <span>€</span>
                        </div>
                    </div>

                    <div class="flex flex-col gap-2">
                        <div class="flex flex-col">
                            <v-label>Комиссия в сумме</v-label>
                            <span :class="r.feeInAmount ? 'font-bold' : 'text-gray-700'">{{ r.feeInAmount ? 'Да' : 'Нет' }}</span>
                        </div>
                        <div class="flex flex-col">
                            <v-label>Сумма, которую получил клиент</v-label>
                            <span class="font-mono">{{ r.amountToReceive }}</span>
                        </div>
                        <div class="flex flex-col">
                            <v-label>Комиссия сети</v-label>
                            <span class="font-mono">{{ r.blockchainFeeTo }}</span>
                        </div>
                        <div class="flex flex-col">
                            <v-label>Источник списания комиссии сети</v-label>
                            <span class="font-mono">{{ r.blockchainFeeToSource || '-' }}</span>
                        </div>
                        <div class="flex flex-col">
                            <v-label>Комиссия сервиса</v-label>
                            <div class="flex flex-row gap-2">
                                <span class="font-mono">{{ r.serviceFeeUSD }}</span>
                                <span>$</span>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-col text-center gap-2">
                        <div class="flex flex-col">
                            <v-label>Создания (UTC)</v-label>
                            <span>{{ moment(r.createdAt).utc().format('L LTS') }}</span>
                        </div>
                        <div class="flex flex-col">
                            <v-label>Обновления (UTC)</v-label>
                            <span>{{ moment(r.updatedAt).utc().format('L LTS') }}</span>
                        </div>
                    </div>

                    <pre v-if="r.showDetails" class="col-span-full p-2 bg-gray-100 text-xs">{{ r }}}</pre>

                    <div class="col-span-full text-center text-xs p-2">
                        <span v-if="r.showDetails" class="cursor-pointer hover:font-bold" @click="r.showDetails = false">Скрыть</span>
                        <span v-else class="cursor-pointer hover:font-bold" @click="r.showDetails = true">Подробнее</span>
                    </div>
                </div>

            </div>

            <div class="flex flex-row justify-center">
                <v-pagination :count="parseInt(result.count)" :page="page" :limit="limit" :paginate="paginate" />
            </div>

        </div>
    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import OrganizationNav from '@/Components/Navigation/Organization';
import VInput from "@/Components/Input";
import VButton from "@/Components/Button";
import VSelect from "@/Components/Select";
import moment from "moment";
import VPagination from "@/Components/PaginationOffset.vue";
import VLabel from "@/Components/Label.vue";

export default {
    components: {
        VLabel,
        Head, Link,
        AuthenticatedLayout,
        OrganizationNav,
        VInput,
        VButton,
        VSelect,
        VPagination,
    },
    props: {
        notifications: Object,
        success: Boolean,
        result: Object,
        page: Number,
        offset: Number,
        limit: Number,
        type: String,
        status: String,
        search: String,
    },
    methods: {
        moment,
        paginate(page = 1) {
            const { type, status, search } = this;
            useForm({ page, type, status, search })
                .get(this.route(this.route().current()))
        },
    },
}
</script>
